import { defineMessages } from "react-intl";

export const scope = "components.HisotryDetailsReward";

export const messages = defineMessages({
  statusInProgress: {
    id: `${scope}.statusInProgress`,
    defaultMessage: "Pendiente",
  },
  statusFailed: {
    id: `${scope}.statusFailed`,
    defaultMessage: "Falló",
  },
  statusOk: {
    id: `${scope}.statusOk`,
    defaultMessage: "Finalizado",
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: "Estado",
  },

  movementId: {
    id: `${scope}.movementId`,
    defaultMessage: "Id de movimiento",
  },
  type: {
    id: `${scope}.type`,
    defaultMessage: "Tipo",
  },
  adjustmentAmount: {
    id: `${scope}.adjustmentAmount`,
    defaultMessage: "Monto",
  },
  approved: {
    id: `${scope}.approved`,
    defaultMessage: "Aprobado",
  },
  rejected: {
    id: `${scope}.rejected`,
    defaultMessage: "Rechazado",
  },
  details: {
    id: `${scope}.details`,
    defaultMessage: "Detalle",
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: "Descripcion",
  },
});
